/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    SCREEN_TRANSITION = "screen_transition",
    NEAR_WIN = "near_win",
    SCREENS = "screens",
    WIN_COUNT_UP = "win_count_up",
    BIG_WIN = "big_win",
    WIN_PRESENTATIONS = "win_presentations",
    XBET_LAMP = "xBet_lamp",
    ENHANCER_NUDGE_OVERLAY = "enhancer_nudge_overlay",
    REEL_LOCK = "reel_lock",
    HIGH_SYMBOLS_STICKY = "high_symbols_sticky",
    LOW_SYMBOLS_STICKY = "low_symbols_sticky",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    LOW_SYMBOLS_WIN = "low_symbols_win",

    HIGH_SYMBOLS = "high_symbols",
    LOW_SYMBOLS = "low_symbols",
    REEL_BACKGROUND = "reel_background",
    BACKGROUND = "background"
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize():void {
        this.children.forEach((c:any) => {
            if(c.onResize) {
                c.onResize();
            }
        });
    }

    public onOrientationChanged():void {
        this.children.forEach((c:any) => {
            if(c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        });
    }

    public addChild<T extends PIXI.DisplayObject>(...children:T[]):T {
        children.forEach((c:any) => {
            if(c.onResize) {
                c.onResize();
            }
            if(c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        })

        return super.addChild(...children);
    }
}

export class SerialLayers {

    constructor() {
        for(const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name:string):StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }

    public static get stage():PIXI.Container {
        return SerialLayers.getLayer(Layers.BACKGROUND)!.parent!;
    }
}